// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';

// Utils
import {
    getNotificationBoardTitle,
    getNotificationElementId,
} from '../../../../../../../common/notifications/notificationModelUtils';
import { getTitle } from '../../../../../../../common/elements/utils/elementPropertyUtils';

// Components
import BaseNotificationEntry from './BaseNotificationEntry';
import UserNames from './UserNames';
import NotificationUserFigure from './NotificationFigureUser';
import Icon from '../../../../../../components/icons/Icon';

const BoardTitle = (props) => {
    const { group, element, notification } = props;

    const groupId = get('id', group);
    const boardId = getNotificationElementId(notification);

    if (groupId === boardId) return <span>this board</span>;

    const boardTitle = getTitle(element) || getNotificationBoardTitle(notification);

    if (!boardTitle) return <span>a board</span>;

    return <span className="board-title">{boardTitle}</span>;
};

const NotificationEntryShare = (props) => {
    const { actors } = props;

    return (
        <BaseNotificationEntry
            {...props}
            className="NotificationEntryShare"
            figure={<NotificationUserFigure {...props} icon={<Icon name="notification-share" />} />}
        >
            <div className="notification-statement">
                <UserNames users={actors} /> shared <BoardTitle {...props} /> with you
            </div>
        </BaseNotificationEntry>
    );
};

BoardTitle.propTypes = NotificationEntryShare.propTypes = {
    element: PropTypes.object,
    group: PropTypes.object,
    actors: PropTypes.array,
    notification: PropTypes.object,
    previousLastCheckedNotifications: PropTypes.number,
};

export default NotificationEntryShare;
